import React from 'react'
import ReactDOM from 'react-dom'

import store from 'embo/store'
import {loadEvent} from 'embo/api/dom'
import {addEntities} from 'embo/state/entities'
import {enqueue, setCurrentTrack, presentTrack} from 'embo/state/playlist'
import {
  setPlaylistVisible,
  setPlaying,
} from 'embo/state/player'

import Player from 'embo/components/player/App'

import {on} from 'embo/utils/events'


// Ces fonctions dispatchent plusieurs actions hors d'un handler React
// (delegation DOM via `on()`), donc non batchées par défaut : sans
// unstable_batchedUpdates, chaque dispatch provoque un rendu séparé du
// composant Audio, qui perd la synchronisation de ses refs
// usePrevious(src/playing) et relance play() en double — l'élément <audio>
// reste alors dans un état qui ignore les pause() ultérieurs depuis le player.

function enqueueEvent(eventId) {
  const {entities} = store.getState()
  // event might be loaded, but not necessarily enqueued
  if (entities.event[eventId]) {
    const trackIds = Object.keys(entities.track).filter(trackId => {
      return entities.track[trackId].event === eventId
    })
    store.dispatch(enqueue(trackIds))
    return Promise.resolve(trackIds[0])
  }
  return loadEvent(eventId).then(data => {
    const trackIds = Object.keys(data.entities.track)
    ReactDOM.unstable_batchedUpdates(() => {
      store.dispatch(addEntities(data.entities))
      store.dispatch(enqueue(trackIds))
    })
    return trackIds[0]
  })
}


function enqueuePerformance(performanceId, eventId) {
  const {entities} = store.getState()
  // performer might be loaded, but not necessarily enqueued
  if (entities.performer[performanceId]) {
    const trackIds = entities.performer[performanceId].track
    store.dispatch(enqueue(trackIds))
    return Promise.resolve(trackIds[0])
  }
  return loadEvent(eventId).then(data => {
    const performer = data.entities.performer[performanceId]
    ReactDOM.unstable_batchedUpdates(() => {
      store.dispatch(addEntities(data.entities))
      store.dispatch(enqueue(performer.track))
    })
    return performer.track[0]
  })
}


function showTrack(trackId) {
  ReactDOM.unstable_batchedUpdates(() => {
    store.dispatch(setPlaylistVisible(true))
    store.dispatch(presentTrack(trackId))
  })
}

function playTrack(trackId) {
  ReactDOM.unstable_batchedUpdates(() => {
    store.dispatch(setCurrentTrack(trackId))
    showTrack(trackId)
    store.dispatch(setPlaying(true))
  })
}


export default function initializePlayer() {

  ReactDOM.render(
    <Player store={store}/>,
    document.getElementById('embo-main-player'),
  )

  const {body} = document

  on(body, 'click', '.btn-event-enqueue', ({target}) => {
    const {eventId} = target.dataset
    enqueueEvent(eventId).then(showTrack)
  })
  on(body, 'click', '.btn-event-play', ({target}) => {
    const {eventId} = target.dataset
    enqueueEvent(eventId).then(playTrack)
  })
  on(body, 'click', '.btn-performance-enqueue', ({target}) => {
    const {eventId, performanceId} = target.dataset
    enqueuePerformance(performanceId, eventId).then(showTrack)
  })
  on(body, 'click', '.btn-performance-play', ({target}) => {
    const {eventId, performanceId} = target.dataset
    enqueuePerformance(performanceId, eventId).then(playTrack)
  })

}
